<template>
  <div class="VeiwsUrl">
    <iframe class="VeiwsUrlIfram" :src="$route.query.url" frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "VeiwsUrl",
  created(){
    this.vuexAllPark(false)
  },
  methods:{
    ...mapMutations([
      'vuexAllPark'
    ]),
  },
}
</script>

<style lang="less" scoped>
.VeiwsUrl {
  .VeiwsUrlIfram {
    width: 100%;
    height: 100vh;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/park/VeiwsUrl.vue